import { Grid, Typography } from '@mui/material';
import { useAlert } from './hook';
import { AlertProps } from './props';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import FieldText from '../../../../../components/general/fields/fieldText';
import { formatParams } from '../../../../../../shared/utils/params';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import RichText from '../../../../../components/richText';

export const Alert = (props: AlertProps) => {
    const { formik, typesAlertDate, typesClassification } = useAlert(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Alerta
                </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(typesAlertDate)}
                    label="Fecha"
                    name="alertDate"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.alertDate}
                    errors={formik.errors.alertDate}
                    value={formik.values.alertDate as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('alertDate', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(typesClassification)}
                    label="Clasificación"
                    name="classification"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.classification}
                    errors={formik.errors.classification}
                    value={formik.values.classification as string}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('classification', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número de días"
                    type="number"
                    name="numberDays"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.numberDays}
                    errors={formik.errors.numberDays}
                    value={formik.values.numberDays}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <Checkbox
                    label="Alerta por correo"
                    checked={Boolean(formik.values.alertByMail)}
                    onChange={() => {
                        formik.setFieldValue(
                            'alertByMail',
                            !formik.values.alertByMail
                        );
                    }}
                />
            </Grid>
            {formik.values.alertByMail && (
                <>
                    <Grid item xs={12}>
                        <FieldText
                            label="Funcionarios seleccionados en el formulario de PQR el el redireccionamiento"
                            name="emailOfficials"
                            placeholder="Las direcciones de correo electrónico deben estar separadas por punto y coma"
                            size="small"
                            rows={2}
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.emailOfficials}
                            errors={formik.errors.emailOfficials}
                            value={formik.values.emailOfficials as string}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <AutocompleteField
                            data={formatParams(typesAlertDate)}
                            label="Tags"
                            name="tags"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.tags}
                            errors={formik.errors.tags}
                            value={formik.values.tags as string}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('tags', value)
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <FieldText
                            label="Asunto"
                            name="subject"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.subject}
                            errors={formik.errors.subject}
                            value={formik.values.subject as string}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <RichText
                            initialContent={formik.values.template}
                            editable
                            onContentChange={(content) =>
                                formik.setFieldValue('template', content)
                            }
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
